import Vue from 'vue';
import VueRouter from 'vue-router';
import App from './App.vue';
import router from './router';
import store from './store';
import mixins from './mixins';
import plugin from './config/plugin.js';
// import './config/rem.js';
import clipper from './config/clipper'
import BaiduMap from 'vue-baidu-map'
Vue.use(clipper);
// 挂载
Vue.use(VueRouter);
Vue.use(plugin, store, router);
// 注册全局mixins.
Vue.mixin(mixins);
Vue.use(BaiduMap, {
  ak: 'piXQ5CgHFqEefqCVbhhBFfe6HjF7l4zW'
})


new Vue({
  router,
  store,
  components: { App },
  template: '<App/>',
}).$mount('#app');
// eslint-disable-next-line
const _hmt = _hmt || [];
// eslint-disable-next-line
window._hmt = _hmt; // 必须把_hmt挂载到window下，否则找不到
(function () {
  const hm = document.createElement('script');
  hm.src = "https://hm.baidu.com/hm.js?df26bd74dd936cf6f4555c7577a3bc80";
  const s = document.getElementsByTagName('script')[0];
  s.parentNode.insertBefore(hm, s);
}());

router.beforeEach(function (to, from, next) {
  if (to.path) {
    _hmt.push(['_trackPageview', to.fullPath])
  }
  next();
  // store.commit('updateLoadingStatus', {isLoading: true})
})



// WEBPACK FOOTER //
// ./src/main.js